import classNames from "classnames";
import { forwardRef } from "react";
import PhoneInputModule, { PhoneInputProps } from "react-phone-input-2";
import { __, language } from "@common/helpers/i18n";
import { InputProps } from "@common/types";
import "./mobile.css";
import { Input, getInputClassName } from "./Input";
import { getResolvedFieldPlaceholder } from "./fieldPlaceholder";

const PhoneInput = (
  "default" in PhoneInputModule ? PhoneInputModule.default : PhoneInputModule
) as typeof PhoneInputModule;

type MobileProps = InputProps &
  PhoneInputProps & {
    className?: string;
  };

export const Mobile = forwardRef<HTMLInputElement, MobileProps>(function Mobile(
  {
    label,
    error,
    hint,
    loading,
    icon,
    iconPosition,
    success,
    autoWidth,
    inputProps,
    className,
    containerClass,
    inputClass,
    buttonClass,
    placeholder,
    ...props
  },
  ref,
) {
  const resolvedInputProps =
    inputProps && typeof inputProps === "object"
      ? (inputProps as Record<string, unknown>)
      : {};
  const resolvedPlaceholder = getResolvedFieldPlaceholder(
    label,
    placeholder,
    "input",
    "tel",
  );
  const resolvedPhoneInputProps = {
    ...resolvedInputProps,
    dir: resolvedInputProps.dir ?? "ltr",
    placeholder:
      resolvedInputProps.placeholder ??
      resolvedPlaceholder ??
      __("For example, 9123456789"),
    ...(ref ? { ref } : {}),
  };

  return (
    <Input
      label={label}
      error={error}
      hint={hint}
      loading={loading}
      icon={icon}
      iconPosition={iconPosition}
      success={success}
      className={className}
    >
      <PhoneInput
        country={language.split("-")[1].toLowerCase()}
        inputClass={classNames(
          !autoWidth && "block w-full",
          getInputClassName(error ? "danger" : success ? "success" : "default"),
          inputClass,
        )}
        containerClass={classNames(
          "max-w-lg [direction:ltr] rounded-md",
          containerClass,
        )}
        buttonClass={buttonClass}
        inputStyle={{ width: "100%", height: "unset", lineHeight: "1.5rem" }}
        buttonStyle={{ borderRadius: "0.375rem 0 0 0.375rem" }}
        placeholder={resolvedPlaceholder ?? __("For example, 9123456789")}
        inputProps={resolvedPhoneInputProps}
        {...props}
      />
    </Input>
  );
});
